import React from 'react';
import { Hero } from '../components/home/Hero';
import { WhatIsDTech } from '../components/home/WhatIsDTech';
import { ProductShowcase } from '../components/home/ProductShowcase';
import { AvailabilityDelivery } from '../components/home/AvailabilityDelivery';
import { WhyDTechUnified } from '../components/home/WhyDTechUnified';
import { Applications } from '../components/home/Applications';
import { DemoRequest } from '../components/home/DemoRequest';
import { PromoPopup } from '../components/home/PromoPopup';
interface HomePageProps {
  onRequestQuote: (productId?: string) => void;
}
export function HomePage({
  onRequestQuote
}: HomePageProps) {
  return <main data-id="element-762">
      <PromoPopup onRequestQuote={() => onRequestQuote()} data-id="element-763" />
      <Hero onRequestQuote={() => onRequestQuote()} data-id="element-764" />
      <WhatIsDTech data-id="element-765" />
      <ProductShowcase onRequestQuote={onRequestQuote} data-id="element-766" />
      <AvailabilityDelivery onRequestQuote={() => onRequestQuote()} data-id="element-767" />
      <WhyDTechUnified data-id="element-768" />
      <Applications data-id="element-769" />
      <DemoRequest onRequestQuote={() => onRequestQuote()} data-id="element-770" />
    </main>;
}